<template>
    <aside class="nav-new-drawer">
        <header class="drawer-header">
            <div class="drawer-title-group">
                <Icon :name="navItem?.icon?.name" class="drawer-title-icon" />
                <h2 class="drawer-title">{{ navItem?.label }}</h2>
            </div>
            <button class="drawer-close-btn" @click="$emit('close')" title="Close drawer">
                <Icon name="chevron-left" />
            </button>
        </header>
        <div class="drawer-content">
            <!-- Temporary Teleport target for grid controls — remove when action component is built -->
            <div id="nav-drawer-grid-controls" v-show="!hasDrawerContent"></div>
            <slot name="drawer-content"></slot>
        </div>
    </aside>
</template>

<script setup>
import Icon from '@common/icon/Icon.vue';

defineProps({
    navItem: {
        type: Object,
        default: null
    },
    hasDrawerContent: {
        type: Boolean,
        default: false
    }
});

defineEmits(['close']);
</script>

<style>
.drawer-nav-button button span::before {
    margin-left: 5px;
}
</style>

<style scoped>
.nav-new-drawer {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    animation: slideIn 0.18s ease-out;
}

.drawer-content {
    flex: 1;
    overflow-y: auto;
    padding: 0.75rem 1rem 1rem;
    min-height: 0;
}

.drawer-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.75rem 1rem;
    border-bottom: 1px solid #e0e0e0;
}

.drawer-title-group {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
}

.drawer-title-icon {
    color: #6b7280;
}

.drawer-title {
    margin: 0;
    font-size: 1rem;
    font-weight: 600;
    color: #111827;
}

.drawer-close-btn {
    border: none;
    background: none;
    cursor: pointer;
    color: #6b7280;
    border-radius: 999px;
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.15s ease, color 0.15s ease;
}

.drawer-close-btn:hover {
    background-color: #f3f4f6;
    color: #111827;
}

@keyframes slideIn {
    from {
        transform: translateX(-8px);
        opacity: 0;
    }
    to {
        transform: translateX(0);
        opacity: 1;
    }
}
</style>
